export enum RoleName {
  PrimaryOwner = 'เจ้าของฟาร์ม',
  SecondaryOwner = 'รองเจ้าของฟาร์ม',
  Admin = 'admin',
}

export enum RoleType {
  Custom = 'custom',
  Default = 'default',
}
